import { render, staticRenderFns } from "./TheOrganizationGeneralForm.vue?vue&type=template&id=a7da0896&"
import script from "./TheOrganizationGeneralForm.vue?vue&type=script&lang=js&"
export * from "./TheOrganizationGeneralForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports